module.exports = __webpack_public_path__ + "static/media/landing_page_explo.554fdd69.png";